<!-- Precisa de ajuda -->
<div class="container" (click)="irParaAjuda()">
  <p>{{ width <= 767 ? "Ajuda?" : "Precisa de Ajuda?" }}</p>
</div>

<!-- Página -->
<div class="main">
  <header>
    <div class="header">
      <img
        (click)="irParaHome()"
        class="logo__lovers"
        src="assets/images/palito-premiado/logo-lovers.png"
        alt="Logo Cacau Lovers"
        title="Logo Cacau Lovers"
      />
      <nav title="Barra de navegação">
        <p
          (click)="scrollToComoParticipar()"
          class="links"
          title="Como Participar"
        >
          Como Parcitipar
        </p>
        <p (click)="scrollToDuvidas()" class="links" title="Dúvidas">Dúvidas</p>
        <p (click)="abrirModalRegulamento()" class="links" title="Regulamento">
          Regulamento
        </p>
      </nav>
      <div class="button__logocs__container">
        <button (click)="scrollToVoucher()">Inserir código</button>
        <img
          (click)="irParaEcom()"
          class="logo__cacau__show"
          src="assets/images/palito-premiado/logo-cs.png"
          alt="Logo Cacau Show"
          title="Logo Cacau Show"
        />
        <div
          class="hamburguer__menu"
          (click)="iconHamburguer()"
          [ngClass]="{
            active: hamburguerActive,
            desactive: !hamburguerActive
          }"
        >
          <div class="bar--top"></div>
          <div class="bar--mid"></div>
          <div class="bar--bottom"></div>
        </div>
      </div>
    </div>
    <div
      [ngClass]="{ active: hamburguerActive, desactive: !hamburguerActive }"
      class="menu__hamburguer"
    >
      <p (click)="scrollToComoParticipar()">Como participar</p>
      <p (click)="scrollToDuvidas()">Dúvidas</p>
      <p (click)="abrirModalRegulamento()">Regulamento</p>
      <p (click)="irParaEcom()">Loja Online</p>
    </div>
  </header>
  <main>
    <section class="banner">
      <img
        class="img__banner"
        src="assets/images/palito-premiado/banner-desktop.png"
        alt="Logo Cacau Show"
        title="Logo Cacau Show"
      />
      <img
        class="img__banner__mobile"
        src="assets/images/palito-premiado/banner-mobile.png"
        alt="Logo Cacau Show"
        title="Logo Cacau Show"
      />
    </section>
    <section id="comoParticipar" class="explicacao">
      <img
        class="coqueiro"
        src="assets/images/palito-premiado/coqueiro.png"
        alt="Coqueiro"
        title="Coqueiro"
      />
      <img
        class="achou__ganhou"
        src="assets/images/palito-premiado/achou-ganhou.png"
        alt="Achou ganhou"
        title="Achou ganhou"
      />
      <img
        class="achou__ganhou__mobile"
        src="assets/images/palito-premiado/achou-ganhou-mobile.svg"
        alt="Achou ganhou"
        title="Achou ganhou"
      />
      <img
        class="palito__premiado"
        src="assets/images/palito-premiado/encontrou-premio.svg"
        alt="Palito Premiado"
        title="Palito Premiado"
      />
      <img
        class="palito__premiado__mobile"
        src="assets/images/palito-premiado/encontrou-premio-mobile.png"
        alt="Palito Premiado"
        title="Palito Premiado"
      />
    </section>
    <section class="novo__sabor__premio__container">
      <img
        class="sabor_pistache"
        src="assets/images/palito-premiado/novo-sabor-pistache.png"
        alt="Sabor Pistache"
        title="Sabor Pistache"
      />
      <div id="voucherInput" class="voucher__container">
        <img
          class="circulo__verde"
          src="assets/images/palito-premiado/circulo-verde.png"
          alt="Circulo verde"
          title="Circulo verde"
        />
        <img
          class="moeda__cacau"
          src="assets/images/palito-premiado/moeda_cacau.svg"
          alt="Moeda Cacau Lovers"
          title="Moeda Cacau Lovers"
        />
        <div class="voucher">
          <p class="pergunta">
            Ganhou <span>Cacaus</span> ou um
            <span>Verão de Gelatos</span> grátis?
          </p>
          <p class="explica__pergunta">
            Clique no botão abaixo para fazer login em Cacau Lovers e aceitar os
            termos para inserir o código do seu prêmio.
          </p>
          <form class="form" [formGroup]="voucherForm" (ngSubmit)="voucher()">
            <div class="lovers__input">
              <input
                *ngIf="membro !== undefined"
                type="text"
                class="input"
                [ngClass]="{
                  comErro:
                    voucherInvalido ||
                    voucherJaUtilizado ||
                    voucherNaoEncontrado ||
                    voucherNaoConsumido
                }"
                placeholder=" "
                formControlName="codigo"
                inputmode="email"
                id="codigo"
              />
              <label for="voucher" class="label"
                >Código do palito premiado</label
              >
              <p *ngIf="voucherInvalido" class="error">Código inválido.</p>
              <p *ngIf="voucherNaoEncontrado" class="error">
                Código não encontrado.
              </p>
              <p *ngIf="voucherNaoConsumido" class="error">
                Houve um problem ao usar o seu voucher.
              </p>
              <p *ngIf="voucherJaUtilizado" class="error">
                O código inserido já foi utilizado.
              </p>
            </div>
            <button
              [ngClass]="{
                carregando: carregandoVoucher,
                comErro:
                  voucherInvalido ||
                  voucherJaUtilizado ||
                  voucherNaoEncontrado ||
                  voucherNaoConsumido
              }"
              type="submit"
              class="botao__resgate"
            >
              Resgate seu prêmio
              <i *ngIf="carregandoVoucher" class="fa fa-spinner fa-spin"></i>
            </button>
          </form>
        </div>
      </div>
    </section>

    <section class="cta__ecom" alt="E-commerce" title="E-commerce">
      <p class="titulo" title="Ainda não garantiu o seu gelato?">
        Ainda não garantiu o seu gelato?
      </p>
      <p
        class="desc"
        title="Não perca tempo, compre agora mesmo e encontre os palitos premiados!"
      >
        Compre agora mesmo ou vá até uma das lojas participantes!
      </p>
      <button (click)="irParaEcomGelatos()">Comprar meu gelato</button>
      <img
        class="gelatos"
        src="assets/images/palito-premiado/gelatos.png"
        alt="Gelatos"
        title="Gelatos"
      />
    </section>

    <section class="promocional__duvidas" id="duvidas">
      <div class="duvidas__header">
        <p class="header__titulo">Dúvidas Frequentes</p>
      </div>

      <article class="duvidas__faq">
        <faq-novo [faq]="faq" [verMais]="true"></faq-novo>
      </article>

      <p class="duvidas__regulamento" id="regulamento">
        Para mais informações sobre a promoção, confira o
        <span class="regulamento__link" (click)="abrirModalRegulamento()"
          >regulamento</span
        >
        completo.
      </p>
    </section>

    <section class="moeda__palmeira__container">
      <img
        class="moedas__cacaus"
        src="assets/images/palito-premiado/moedas-cacau.png"
        alt="Moeda Cacau Lovers"
        title="Moeda Cacau Lovers"
      />
      <img
        class="coqueiro__footer"
        src="assets/images/palito-premiado/coqueiro_footer.png"
        alt="Coqueiro"
        title="Coqueiro"
      />
    </section>
  </main>
</div>

<!-- Popups -->
<!-- Regulamento -->
<lovers-popup
  [exibir]="exibirModalRegulamento"
  (onClose)="exibirModalRegulamento = false"
>
  <div class="popup__header">
    <p class="header__title">Promoção Palito Premiado</p>
  </div>
  <div class="popup__body">
    <p class="regulamento__titulo">Confira o regulamento e participe!</p>
    <div class="regulamento__texto regulamento__container">
      <p *ngFor="let paragrafo of regulamento">
        {{ paragrafo }}
      </p>
    </div>
  </div>
</lovers-popup>

<!-- Resgate de cacaus -->

<lovers-popup
  [exibir]="exibirPopupResgateCacaus"
  (onClose)="exibirPopupResgateCacaus = false; cacaus = 0"
  tamanho="pequeno2"
>
  <div class="popup__header__resgate">
    <img
      class="moeda__cacau"
      src="assets/images/palito-premiado/moeda_cacau.svg"
      alt="Moeda Cacau Lovers"
      title="Moeda Cacau Lovers"
    />
    <p class="header__title">Você ganhou +{{ cacaus }} cacaus!</p>
  </div>
  <div class="popup__body__resgate">
    <p class="regulamento__titulo">
      Parabéns, você resgatou sua recompensa! Aproveite para resgatar seu
      momento especial.
    </p>
  </div>
  <button (click)="irParaMomentosEspeciais()" class="momento__resgatado">
    Resgatar Momentos Especiais
  </button>
</lovers-popup>

<!-- Resgate de promoção -->

<lovers-popup
  [exibir]="exibirPopupResgatePromocao"
  (onClose)="exibirPopupResgatePromocao = false; promocao = null"
  tamanho="pequeno2"
>
  <div class="popup__header__resgate">
    <img
      class="ganhou__sorvete"
      src="assets/images/palito-premiado/ganhou-sorvete.png"
      alt="Sorvete"
      title="Sorvete"
    />
    <p class="header__title">Você ganhou um Verão de Gelatos grátis!</p>
  </div>
  <div class="popup__body__resgate">
    <p class="regulamento__titulo">
      Uau! Parabéns, você resgatou sua recompensa! Vá a uma loja e aproveite
      seus 65 Gelatos.
    </p>
  </div>
  <button (click)="irParaMeusMomentos()" class="momento__resgatado">
    Ir para Meus Momentos
  </button>
</lovers-popup>
